import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const alertIcon = (type) => (type === "warning" ? <ExclamationCircleOutlined /> : undefined);

export default alertIcon;
